import Vue from 'vue';
import ProductMap from './ProductMap.vue';

document.querySelectorAll('.ProductMap').forEach((node) => {
    new Vue({
        el: node,
        components: {
            ProductMap
        }
    });
});
